import React, { Component } from "react";
import ReactRouterPropTypes from 'react-router-prop-types';
import { Route, withRouter } from "react-router-dom";

import ErrorPageHandler from "./ErrorPageHandler/ErrorPageHandler.jsx";
import MaintenancePage from "./MaintenancePage/MaintenancePage.jsx";
import DefaultSwitch from "../Router/DefaultSwitch.jsx";

class TechnicalPageRouter extends Component {
  static propTypes = {
    match: ReactRouterPropTypes.match
  };

  render() {
    const base = this.props.match.url;

    return (
      <DefaultSwitch>
        <Route path={`${base}/error/:errorCode`}>
          <ErrorPageHandler />
        </Route>
        <Route exact path={`${base}/maintenance`}>
          <MaintenancePage />
        </Route>
      </DefaultSwitch>
    );
  }
}

export default withRouter(TechnicalPageRouter);
